'use client';
'use strict';

var React = require('react');
var getDefaultZIndex = require('../../core/utils/get-default-z-index/get-default-z-index.cjs');
require('clsx');
require('@mantine/hooks');
require('../../core/MantineProvider/Mantine.context.cjs');
require('../../core/MantineProvider/default-theme.cjs');
require('../../core/MantineProvider/MantineProvider.cjs');
require('../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.cjs');
var useProps = require('../../core/MantineProvider/use-props/use-props.cjs');
require('../../core/Box/Box.cjs');
var factory = require('../../core/factory/factory.cjs');
require('../../core/DirectionProvider/DirectionProvider.cjs');
var ModalBody = require('./ModalBody.cjs');
var ModalCloseButton = require('./ModalCloseButton.cjs');
var ModalContent = require('./ModalContent.cjs');
var ModalHeader = require('./ModalHeader.cjs');
var ModalOverlay = require('./ModalOverlay.cjs');
var ModalRoot = require('./ModalRoot.cjs');
var ModalTitle = require('./ModalTitle.cjs');
var Modal_module = require('./Modal.module.css.cjs');

const defaultProps = {
  closeOnClickOutside: true,
  withinPortal: true,
  lockScroll: true,
  trapFocus: true,
  returnFocus: true,
  closeOnEscape: true,
  keepMounted: false,
  zIndex: getDefaultZIndex.getDefaultZIndex("modal"),
  transitionProps: { duration: 200, transition: "pop" },
  withOverlay: true,
  withCloseButton: true
};
const Modal = factory.factory((_props, ref) => {
  const {
    title,
    withOverlay,
    overlayProps,
    withCloseButton,
    closeButtonProps,
    children,
    radius,
    ...others
  } = useProps.useProps("Modal", defaultProps, _props);
  const hasHeader = !!title || withCloseButton;
  return /* @__PURE__ */ React.createElement(ModalRoot.ModalRoot, { ref, radius, ...others }, withOverlay && /* @__PURE__ */ React.createElement(ModalOverlay.ModalOverlay, { ...overlayProps }), /* @__PURE__ */ React.createElement(ModalContent.ModalContent, { radius }, hasHeader && /* @__PURE__ */ React.createElement(ModalHeader.ModalHeader, null, title && /* @__PURE__ */ React.createElement(ModalTitle.ModalTitle, null, title), withCloseButton && /* @__PURE__ */ React.createElement(ModalCloseButton.ModalCloseButton, { ...closeButtonProps })), /* @__PURE__ */ React.createElement(ModalBody.ModalBody, null, children)));
});
Modal.classes = Modal_module;
Modal.displayName = "@mantine/core/Modal";
Modal.Root = ModalRoot.ModalRoot;
Modal.Overlay = ModalOverlay.ModalOverlay;
Modal.Content = ModalContent.ModalContent;
Modal.Body = ModalBody.ModalBody;
Modal.Header = ModalHeader.ModalHeader;
Modal.Title = ModalTitle.ModalTitle;
Modal.CloseButton = ModalCloseButton.ModalCloseButton;

exports.Modal = Modal;
//# sourceMappingURL=Modal.cjs.map
